import { Component, ViewChild, ViewChildren, QueryList, ChangeDetectorRef, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators, FormArray } from '@angular/forms';
import { FormlyFormOptions, FormlyFieldConfig } from '@ngx-formly/core';
import { MatTableDataSource, MatTable } from '@angular/material/table';
import { CurrencyPipe, PercentPipe, DecimalPipe } from '@angular/common';

import {
  ChartComponent,
  ApexAxisChartSeries,
  ApexTitleSubtitle,
  ApexDataLabels,
  ApexChart,
  ApexPlotOptions,
  ApexXAxis,
  ApexYAxis,
} from "ng-apexcharts";
import { MatSort } from '@angular/material/sort';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { CalculationService } from './services/calculation.service';

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  fill: any;
  colors: any;
  title: ApexTitleSubtitle;
  xaxis: ApexXAxis;
  yaxis: ApexYAxis;
  plotOptions: ApexPlotOptions;
};

export interface Statistic {
  metric: string;
  need: string;
}
const ELEMENT_DATA: Statistic[] = [
  { metric: 'Rate of Return', need: 'N/A'},
  { metric: 'Standard Deviation', need: 'N/A'},
  { metric: 'Variance Drag Phantom Tax', need: 'N/A'},
  { metric: 'Sharpe Ratio', need: 'N/A'},
  { metric: 'Probability of Any Loss in the Next 12 Months', need: 'N/A'},
  { metric: 'Amount of Money at Risk in the Next 12 Months', need: 'N/A'},
  { metric: 'Upper Return', need: 'N/A'},
  { metric: 'Lower Return', need: 'N/A'},
];


export interface Allocation {
  allocation_id: number;
  allocation_percentage: number;
  allocation_value: number;
  categories: Category[];
}

export interface Category {
  category_id: number;
  category_name: string;
  category_percentage: number;
  category_value: number;
  assets: Asset[] | MatTableDataSource<Asset>;
}

export interface Asset {
  asset_id: number;
  asset_name: string;
  asset_ticker: string;
  asset_percentage: number;
  asset_value: number;
}
const ALLOCATION: Allocation = {
	allocation_id: 0,
	allocation_percentage: 0,
	allocation_value: 0,
	categories: [
	  	{
			  "category_id": 1,
			  "category_name": "Money Market",
			  "category_percentage": 0,
		"category_value": 0,
			  "assets": [
				  {
					  "asset_id": 1,
					  "asset_name": "Tax-Free Cash",
					  "asset_ticker": "VMSXX",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 2,
					  "asset_name": "Taxable Cash",
					  "asset_ticker": "VMFXX",
					  "asset_percentage": 0,"asset_value": 0
				  }
			  ]
		  },
		  {
			  "category_id": 2,
			  "category_name": "Fixed Income",
			  "category_percentage": 0,
		"category_value": 0,
			  "assets": [
				  {
					  "asset_id": 3,
					  "asset_name": "Corporate Bonds",
					  "asset_ticker": "XCB.TO",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 4,
					  "asset_name": "Emerging Markets Debt",
					  "asset_ticker": "MSD",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 5,
					  "asset_name": "Government Bonds",
					  "asset_ticker": "SNSXX",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 6,
					  "asset_name": "High Yield Bonds",
					  "asset_ticker": "JNK",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 7,
					  "asset_name": "Municipal Bonds",
					  "asset_ticker": "LMBIX",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 8,
					  "asset_name": "International Fixed Income",
					  "asset_ticker": "SEFIX",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 9,
					  "asset_name": "U.S. Treasury (1-3 Years)",
					  "asset_ticker": "SHY",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 10,
					  "asset_name": "U.S. Treasury (1-10 Years)",
					  "asset_ticker": "IEF",
					  "asset_percentage": 0,"asset_value": 0
				  }
			  ]
		  },
		  {
			  "category_id": 3,
			  "category_name": "Hard Assets",
			  "category_percentage": 0,
		"category_value": 0,
			  "assets": [
				  {
					  "asset_id": 11,
					  "asset_name": "Commodities",
					  "asset_ticker": "DBC",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 12,
					  "asset_name": "Global Timber & Forestry Index",
					  "asset_ticker": "WOOD",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 13,
					  "asset_name": "Gold Index",
					  "asset_ticker": "IAU",
					  "asset_percentage": 0,"asset_value": 0
				  }
			  ]
		  },
		  {
			  "category_id": 4,
			  "category_name": "Domestic Equities",
			  "category_percentage": 0,
		"category_value": 0,
			  "assets": [
				  {
					  "asset_id": 14,
					  "asset_name": "Transportation Index",
					  "asset_ticker": "IYT",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 15,
					  "asset_name": "Large Cap Growth",
					  "asset_ticker": "IWF",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 16,
					  "asset_name": "Large Cap Value",
					  "asset_ticker": "IWD",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 17,
					  "asset_name": "Mid Cap Growth",
					  "asset_ticker": "IWP",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 18,
					  "asset_name": "Mid Cap Value",
					  "asset_ticker": "IWS",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 19,
					  "asset_name": "S&P 500",
					  "asset_ticker": "IVV",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 20,
					  "asset_name": "Small Cap Growth",
					  "asset_ticker": "IWO",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 21,
					  "asset_name": "Small Cap Value",
					  "asset_ticker": "IWN",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 22,
					  "asset_name": "Specialty Energy",
					  "asset_ticker": "XLE",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 23,
					  "asset_name": "Specialty Financial",
					  "asset_ticker": "XLF",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 24,
					  "asset_name": "Specialty Health",
					  "asset_ticker": "XLV",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 25,
					  "asset_name": "Specialty Metals & Mining",
					  "asset_ticker": "XME",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 26,
					  "asset_name": "Specialty Technology",
					  "asset_ticker": "XLK",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 27,
					  "asset_name": "Specialty Utilities",
					  "asset_ticker": "XLU",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 28,
					  "asset_name": "Broad REIT Index",
					  "asset_ticker": "IYR",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 29,
					  "asset_name": "Consumer Staples",
					  "asset_ticker": "XLP",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 30,
					  "asset_name": "Industrial Metals",
					  "asset_ticker": "DBB",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 31,
					  "asset_name": "Large Cap Blend",
					  "asset_ticker": "IWB",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 32,
					  "asset_name": "Master Limited Partnerships",
					  "asset_ticker": "AMLP",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 33,
					  "asset_name": "Mid Cap Blend",
					  "asset_ticker": "IWR",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 34,
					  "asset_name": "Preferred Stocks Index",
					  "asset_ticker": "PFF",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 35,
					  "asset_name": "Small Cap Blend",
					  "asset_ticker": "IWM",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 107,
					  "asset_name": "Meta Platforms Inc",
					  "asset_ticker": "META",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 108,
					  "asset_name": "Apple Inc",
					  "asset_ticker": "AAPL",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 109,
					  "asset_name": "Microsoft Corp",
					  "asset_ticker": "MSFT",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 110,
					  "asset_name": "Alphabet Inc",
					  "asset_ticker": "GOOGL",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 111,
					  "asset_name": "Amazon.com Inc",
					  "asset_ticker": "AMZN",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 112,
					  "asset_name": "NVIDIA Corp",
					  "asset_ticker": "NVDA",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 113,
					  "asset_name": "UnitedHealth Group Inc",
					  "asset_ticker": "UNH",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 114,
					  "asset_name": "Berkshire Hathaway Inc",
					  "asset_ticker": "BRK.A",
					  "asset_percentage": 0,"asset_value": 0
				  }
			  ]
		  },
		  {
			  "category_id": 5,
			  "category_name": "International Equities",
			  "category_percentage": 0,
		"category_value": 0,
			  "assets": [
				  {
					  "asset_id": 36,
					  "asset_name": "Emerging Markets Equity",
					  "asset_ticker": "EEM",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 37,
					  "asset_name": "International Equity",
					  "asset_ticker": "EFA",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 38,
					  "asset_name": "Japan",
					  "asset_ticker": "EWJ",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 39,
					  "asset_name": "Asia/Pacific Rim",
					  "asset_ticker": "AAXJ",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 40,
					  "asset_name": "Latin America",
					  "asset_ticker": "ILF",
					  "asset_percentage": 0,"asset_value": 0
				  }
		  ]
		  },
		  {
			  "category_id": 6,
			  "category_name": "Utilities",
			  "category_percentage": 0,
		"category_value": 0,
			  "assets": [
				  {
					  "asset_id": 41,
					  "asset_name": "American Electric Power",
					  "asset_ticker": "AEP",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 42,
					  "asset_name": "Consolidated Edison, Inc.",
					  "asset_ticker": "ED",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 43,
					  "asset_name": "Dominion Resources, Inc.",
					  "asset_ticker": "D",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 44,
					  "asset_name": "Entergy Corporation",
					  "asset_ticker": "ETR",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 45,
					  "asset_name": "Exelon Corporation",
					  "asset_ticker": "EXC",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 46,
					  "asset_name": "FirstEnergy Corporation",
					  "asset_ticker": "FE",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 47,
					  "asset_name": "Nextera Energy",
					  "asset_ticker": "NEE",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 48,
					  "asset_name": "Portland General Electric",
					  "asset_ticker": "POR",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 49,
					  "asset_name": "PPL Corporation",
					  "asset_ticker": "PPL",
					  "asset_percentage": 0,"asset_value": 0
				  }
			  ]
		  },
		  {
			  "category_id": 7,
			  "category_name": "Senior Rate Floating Notes",
			  "category_percentage": 0,
		"category_value": 0,
			  "assets": [
				  {
					  "asset_id": 50,
					  "asset_name": "BlackRock Floating Rate",
					  "asset_ticker": "BGT",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 51,
					  "asset_name": "BlackRock Ltd. Duration Income",
					  "asset_ticker": "BLW",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 52,
					  "asset_name": "Eaton Vance Floating Rate",
					  "asset_ticker": "EVBLX",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 53,
					  "asset_name": "Eaton Vance Senior Floating-Rate",
					  "asset_ticker": "EFR",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 54,
					  "asset_name": "Apollo Senior Floating Rate Fund Inc.",
					  "asset_ticker": "AFT",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 55,
					  "asset_name": "Nuveen Floating Rate Income",
					  "asset_ticker": "JFR",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 56,
					  "asset_name": "Nuveen Floating Rate Opportunity",
					  "asset_ticker": "JRO",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 57,
					  "asset_name": "Pioneer Floating Rate Trust",
					  "asset_ticker": "PHD",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 58,
					  "asset_name": "Saba Capital Income & Opportunities Fund",
					  "asset_ticker": "BRW",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 59,
					  "asset_name": "MFS Charter Income Trust",
					  "asset_ticker": "MCR",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 60,
					  "asset_name": "MFS Intermediate Income Trust",
					  "asset_ticker": "MIN",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 61,
					  "asset_name": "MFS Multimarket Income Trust",
					  "asset_ticker": "MMT",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 62,
					  "asset_name": "Putnam Intermediate Income Trust",
					  "asset_ticker": "PIM",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 63,
					  "asset_name": "Aberdeen Asia-Pacific Income Fund",
					  "asset_ticker": "FAX",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 64,
					  "asset_name": "BlackRock Income Trust",
					  "asset_ticker": "BKT",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 65,
					  "asset_name": "Invesco Bond Fund",
					  "asset_ticker": "VBF",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 66,
					  "asset_name": "Eaton Vance Ltd Duration Income Fund",
					  "asset_ticker": "EVV",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 67,
					  "asset_name": "BlackRock Debt Strategies Fund, Inc.",
					  "asset_ticker": "DSU",
					  "asset_percentage": 0,"asset_value": 0
				  }
			  ]
		  },
		  {
			  "category_id": 8,
			  "category_name": "Business Development Companies",
			  "category_percentage": 0,
		"category_value": 0,
			  "assets": [
				  {
					  "asset_id": 68,
					  "asset_name": "BlackRock Capital Investment Corp",
					  "asset_ticker": "BKCC",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 69,
					  "asset_name": "Whitehorse Finance",
					  "asset_ticker": "WHF",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 70,
					  "asset_name": "Stellus Capital Investments",
					  "asset_ticker": "SCM",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 71,
					  "asset_name": "TPG Specialty Lending",
					  "asset_ticker": "TSLX",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 72,
					  "asset_name": "FS KKR Capital Corp",
					  "asset_ticker": "FSK",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 73,
					  "asset_name": "Barings BDC Inc.",
					  "asset_ticker": "BBDC",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 74,
					  "asset_name": "Prospect Capital Corp",
					  "asset_ticker": "PSEC",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 75,
					  "asset_name": "MidCap Financial Investment Corp",
					  "asset_ticker": "MFIC",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 76,
					  "asset_name": "Ares Capital Corp",
					  "asset_ticker": "ARCC",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 77,
					  "asset_name": "Capital Southwest Corp",
					  "asset_ticker": "CSWC",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 78,
					  "asset_name": "Gladstone Investment Corp",
					  "asset_ticker": "GAIN",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 79,
					  "asset_name": "Hercules Technology Growth Capital",
					  "asset_ticker": "HTGC",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 80,
					  "asset_name": "Main Street Capital Corp",
					  "asset_ticker": "MAIN",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 81,
					  "asset_name": "Oaktree Specialty Lending Corp",
					  "asset_ticker": "OCSL",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 82,
					  "asset_name": "Saratoga Investment Corp",
					  "asset_ticker": "SAR",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 83,
					  "asset_name": "Monroe Capital Corp",
					  "asset_ticker": "MRCC",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 84,
					  "asset_name": "TCG BDC, Inc.",
					  "asset_ticker": "CGBD",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 85,
					  "asset_name": "Oxford Square Capital Corp",
					  "asset_ticker": "OXSQ",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 86,
					  "asset_name": "Investcorp Credit Management",
					  "asset_ticker": "ICMB",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 87,
					  "asset_name": "TCP Capital Corp",
					  "asset_ticker": "TCPC",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 88,
					  "asset_name": "Portman Ridge Finance Corporation",
					  "asset_ticker": "PTMN",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 89,
					  "asset_name": "Crescent Capital BDC",
					  "asset_ticker": "CCAP",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 90,
					  "asset_name": "Goldman Sachs BDC Inc",
					  "asset_ticker": "GSBD",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 91,
					  "asset_name": "TriplePoint Venture Growth BDC Corp",
					  "asset_ticker": "TPVG",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 92,
					  "asset_name": "Bain Capital Specialty Finance",
					  "asset_ticker": "BCSF",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 93,
					  "asset_name": "PennantPark Investment Corporation",
					  "asset_ticker": "PNNT",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 94,
					  "asset_name": "SLR Investment Corp",
					  "asset_ticker": "SLRC",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 95,
					  "asset_name": "OFS Capital Corp",
					  "asset_ticker": "OFS",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 96,
					  "asset_name": "Fidus Investment Corp",
					  "asset_ticker": "FDUS",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 97,
					  "asset_name": "Owl Rock Capital",
					  "asset_ticker": "ORCC",
					  "asset_percentage": 0,"asset_value": 0
				  }
			  ]
		  },
		  {
			  "category_id": 9,
			  "category_name": "Alternative Investment Strategies",
			  "category_percentage": 0,
		"category_value": 0,
			  "assets": [
				  {
					  "asset_id": 98,
					  "asset_name": "Convertible Arbitrage",
					  "asset_ticker": "N/A",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 99,
					  "asset_name": "Equity Market Neutral",
					  "asset_ticker": "N/A",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 100,
					  "asset_name": "Event Driven",
					  "asset_ticker": "N/A",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 101,
					  "asset_name": "Fixed Income Arbitrage",
					  "asset_ticker": "N/A",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 102,
					  "asset_name": "Global Macro",
					  "asset_ticker": "N/A",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 103,
					  "asset_name": "Long/Short Equity",
					  "asset_ticker": "N/A",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 104,
					  "asset_name": "Merger Arbitrage",
					  "asset_ticker": "N/A",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 105,
					  "asset_name": "Multi-Strategy",
					  "asset_ticker": "N/A",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 106,
					  "asset_name": "Managed Futures",
					  "asset_ticker": "N/A",
					  "asset_percentage": 0,"asset_value": 0
				  }
			  ]
		  },
		  {
			  "category_id": 10,
			  "category_name": "Chapwood Managed Accounts",
			  "category_percentage": 0,
		"category_value": 0,
			  "assets": [
				  {
					  "asset_id": 115,
					  "asset_name": "Emancipation Long/Short Equity",
					  "asset_ticker": "N/A",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 116,
					  "asset_name": "Pawleys Dividend",
					  "asset_ticker": "N/A",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 117,
					  "asset_name": "Pawleys Growth",
					  "asset_ticker": "N/A",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 118,
					  "asset_name": "Pinnacle 130/30",
					  "asset_ticker": "N/A",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 119,
					  "asset_name": "Van Hulzen Covered Call",
					  "asset_ticker": "N/A",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 120,
					  "asset_name": "Millennium",
					  "asset_ticker": "N/A",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 121,
					  "asset_name": "Hudson Bay",
					  "asset_ticker": "N/A",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 122,
					  "asset_name": "Elliott",
					  "asset_ticker": "N/A",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 123,
					  "asset_name": "Third Point",
					  "asset_ticker": "N/A",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 124,
					  "asset_name": "DE Shaw Composite",
					  "asset_ticker": "N/A",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 125,
					  "asset_name": "DE Shaw Oculus",
					  "asset_ticker": "N/A",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 126,
					  "asset_name": "Warrington Strategic",
					  "asset_ticker": "N/A",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 127,
					  "asset_name": "Apollo Global Management Traditional Private Equity",
					  "asset_ticker": "N/A",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 128,
					  "asset_name": "Providence Equity Partner Funds",
					  "asset_ticker": "N/A",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 129,
					  "asset_name": "Kona Funds",
					  "asset_ticker": "N/A",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 130,
					  "asset_name": "Vista Flagship Funds",
					  "asset_ticker": "N/A",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 131,
					  "asset_name": "The Rama Fund",
					  "asset_ticker": "N/A",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 132,
					  "asset_name": "ABR 75/25",
					  "asset_ticker": "VOLSX",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 133,
					  "asset_name": "Warrington Tactical",
					  "asset_ticker": "N/A",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 134,
					  "asset_name": "Pacer US Cash Cows 100 ETF",
					  "asset_ticker": "COWZ",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 135,
					  "asset_name": "Pacer US Small Cap Cash Cows 100 ETF",
					  "asset_ticker": "CALF",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 136,
					  "asset_name": "Pacer Developed Markets International Cash Cows 10",
					  "asset_ticker": "ICOW",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 137,
					  "asset_name": "Pacer Funds Trust - Pacer Global Cash Cows Dividen",
					  "asset_ticker": "GCOW",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 138,
					  "asset_name": "Pacer Emerging Markets Cash Cows 100 ETF",
					  "asset_ticker": "ECOW",
					  "asset_percentage": 0,"asset_value": 0
				  },
				  {
					  "asset_id": 139,
					  "asset_name": "Pacer US Cash Cows Growth ETF",
					  "asset_ticker": "BUL",
					  "asset_percentage": 0,"asset_value": 0
				  },
				{
					"asset_id": 140,
					"asset_name": "The Ambassador Fund",
					"asset_ticker": "N/A",
					"asset_percentage": 0,"asset_value": 0
				}
			  ]
		  }
	]
  }
  



@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed, void', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
      transition('expanded <=> void', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class AppComponent implements OnInit {

  @ViewChild('categorySort', { static: true }) categorySort: MatSort;
  @ViewChildren('assetSort') assetSort: QueryList<MatSort>;
  @ViewChildren('assetTables') assetTables: QueryList<MatTable<Asset>>;

  categoriesDataSource: MatTableDataSource<Category>;
  categoriesData: Category[] = [];
  categoryColumnMap: Map<string,string> = new Map([
    ['category_name', 'Category Name'],
    ['category_percentage', 'Category Percentage'],
    ['category_value', 'Category Value'],
  ])
  assetColumnMap: Map<string,string> = new Map([
    ['asset_name', 'Asset Name'],
    ['asset_percentage', 'Asset Percentage'],
    ['asset_value', 'Asset Value'],
  ])
  categoryColumnsToDisplay = ['category_name', 'category_percentage', 'category_value'];
  assetColumnsToDisplay = ['asset_name', 'asset_percentage', 'asset_value'];
  @ViewChild('outerSort', { static: true }) sort: MatSort;
  @ViewChildren('innerSort') innerSort: QueryList<MatSort>;
  @ViewChildren('innerTables') innerTables: QueryList<MatTable<Asset>>;

  expandedCategory: Category | null;
  portfolioForm: FormGroup;


  @ViewChild("chart") chart: ChartComponent;
  public chartOptions: Partial<ChartOptions>;

  title = 'builder';
  form = new FormGroup({});
  model: any = {};
  options: FormlyFormOptions = {};
  fields: FormlyFieldConfig[] = [
    {
      key: 'startingValue',
      id: 'startingValue',
      type: 'input',
      templateOptions: {
        label: 'Starting Value',
        placeholder: 'Enter a Value',
        description: 'The total value of the portfolio',
        required: true,
        blur: (formlyFieldConfig: FormlyFieldConfig) => {
          if (this.model.startingValue){
            let value: string = (this.model.startingValue as string).replace(/[^0-9.-]+/g,'');
            formlyFieldConfig.parent.fieldGroup.find(k => k.key === 'startingValue').formControl.patchValue(this.currencyPipe.transform(value, 'USD', 'symbol-narrow', '1.0-0'));
          }
        }
      },
      modelOptions: {
        updateOn: 'blur'
      }
    },
    {
      key: 'rateOfReturn',
      id: 'rateOfReturn',
      type: 'input',
      templateOptions: {
        label: 'Rate of Return',
        placeholder: 'Enter a Value',
        description: 'The expected rate of return of the portfolio',
        required: true,
        blur: (formlyFieldConfig: FormlyFieldConfig) => {
          if(this.model.rateOfReturn) {
            let value: string = (this.model.rateOfReturn as string).replace(/[^0-9.-]+/g,'');
            value = (parseFloat(value)/100).toString();
            if (value && value !== 'NaN'){
              formlyFieldConfig.parent.fieldGroup.find(k => k.key === 'rateOfReturn').formControl.patchValue(this.percentPipe.transform(value, '1.0-2'));
            } else {
              formlyFieldConfig.parent.fieldGroup.find(k => k.key === 'rateOfReturn').formControl.patchValue('');
            }
          }
        }
      },
      modelOptions: {
        updateOn: 'blur'
      }
    },
    {
      key: 'standardDeviation',
      id: 'standardDeviation',
      type: 'input',
      templateOptions: {
        label: 'Standard Deviation',
        placeholder: 'Enter a Value',
        description: 'The standard deviation of the portfolio',
        required: true,
        blur: (formlyFieldConfig: FormlyFieldConfig) => {
          if(this.model.standardDeviation) {
            let value: string = (this.model.standardDeviation as string).replace(/[^0-9.-]+/g,'');
            value = (parseFloat(value)/100).toString();
            if (value && value !== 'NaN'){
              formlyFieldConfig.parent.fieldGroup.find(k => k.key === 'standardDeviation').formControl.patchValue(this.percentPipe.transform(value, '1.0-2'));
            } else {
              formlyFieldConfig.parent.fieldGroup.find(k => k.key === 'standardDeviation').formControl.patchValue('');
            }
          }
        }
      },
      modelOptions: {
        updateOn: 'blur'
      }
    },
  ];
  displayedColumns: string[] = ['metric', 'need'];
  dataSource: MatTableDataSource<Statistic> = new MatTableDataSource<Statistic>(ELEMENT_DATA);
  

  // this.percentPipe.transform(parseFloat((this.model.rateOfReturn as string).replace(/[^0-9.-]+/g,'')/100)
  calculateMetrics(){

    let varianceDragPhantomTax = parseFloat(this.model.standardDeviation)/parseFloat( this.model.rateOfReturn);
    let sharpeRatio = (parseFloat( this.model.rateOfReturn) - 2)/parseFloat(this.model.standardDeviation);
    let probabilityOfAnyLoss = this.calculate_probability_loss_in_12_months(parseFloat(this.model.standardDeviation), parseFloat(this.model.rateOfReturn));
    let amountMoneyRisk = this.calculate_amount_money_risk_in_12_months(parseFloat(this.model.standardDeviation), parseFloat(this.model.rateOfReturn), parseFloat((this.model.startingValue as string).replace(/[^0-9.-]+/g,'')));
    let upperReturn = (parseFloat(this.model.rateOfReturn) + 2 * parseFloat(this.model.standardDeviation)) / 100;
    let lowerReturn = (parseFloat(this.model.rateOfReturn) - 2 * parseFloat(this.model.standardDeviation)) / 100;
    let statistic: Statistic[] = [
      { metric: 'Rate of Return', need: this.model.rateOfReturn},
      { metric: 'Standard Deviation', need: this.model.standardDeviation},
      { metric: 'Variance Drag Phantom Tax', need: this.decimalPipe.transform(varianceDragPhantomTax, '1.0-2')},
      { metric: 'Sharpe Ratio', need: this.decimalPipe.transform(sharpeRatio, '1.0-2')},
      { metric: 'Probability of Any Loss in the Next 12 Months', need: this.percentPipe.transform(probabilityOfAnyLoss, '1.0-2')},
      { metric: 'Amount of Money at Risk in the Next 12 Months', need: this.currencyPipe.transform(amountMoneyRisk, 'USD', 'symbol-narrow', '1.0-0')},
      { metric: 'Upper Return', need: this.percentPipe.transform(upperReturn, '1.0-2')},
      { metric: 'Lower Return', need: this.percentPipe.transform(lowerReturn, '1.0-2')},
    ];
    this.dataSource = new MatTableDataSource<Statistic>(statistic);
  }

  /**
   * Calculates the ERF function
   * Returns the value from the ERF function
   * @param {*} x The value to pass into the ERF function
   */
  erf(x) {
    // constants
    var a1 =  0.254829592;
    var a2 = -0.284496736;
    var a3 =  1.421413741;
    var a4 = -1.453152027;
    var a5 =  1.061405429;
    var p  =  0.3275911;

    // Save the sign of x
    var sign = 1;
    if (x < 0) {
        sign = -1;
    }
    x = Math.abs(x);

    // A&S formula 7.1.26
    var t = 1.0/(1.0 + p*x);
    var y = 1.0 - (((((a5*t + a4)*t) + a3)*t + a2)*t + a1)*t*Math.exp(-x*x);

    return sign*y;
}

  /**
   * Calculates the inverse ERF function
   * Returns the value from the inverse ERF function
   * @param {*} x The value to pass into the InvERF function
   */
  erfinv(x){
    var z;
    var a  = 0.147;                                                   
    var the_sign_of_x;
    if(0==x) {
        the_sign_of_x = 0;
    } else if(x>0){
        the_sign_of_x = 1;
    } else {
        the_sign_of_x = -1;
    }

    if(0 != x) {
        var ln_1minus_x_sqrd = Math.log(1-x*x);
        var ln_1minusxx_by_a = ln_1minus_x_sqrd / a;
        var ln_1minusxx_by_2 = ln_1minus_x_sqrd / 2;
        var ln_etc_by2_plus2 = ln_1minusxx_by_2 + (2/(Math.PI * a));
        var first_sqrt = Math.sqrt((ln_etc_by2_plus2*ln_etc_by2_plus2)-ln_1minusxx_by_a);
        var second_sqrt = Math.sqrt(first_sqrt - ln_etc_by2_plus2);
        z = second_sqrt * the_sign_of_x;
    } else { // x is zero
        z = 0;
    }
    return z;
  }

  /**
     * Calculates the CDF given a value on the distribution
     * Returns the value from the CDF funtion
     * @param {*} x The value passed
     * @param {*} mean The average of the distribution
     * @param {*} standard_deviation The standard deviation of the distribution
     */
    cdf(x, mean, standard_deviation) {
      return (1/2) * (1 + this.erf( (x - mean)/(standard_deviation*Math.sqrt(2)) ))
  }

  /**
     * Calculates the Inverse CDF given a value on the distribution
     * Returns the value from the Inverse CDF funtion
     * @param {*} p The value passed
     * @param {*} mean The average of the distribution
     * @param {*} standard_deviation The standard deviation of the distribution
     */
    inv_cdf(p, mean, standard_deviation) {
      return mean + standard_deviation*Math.sqrt(2)*this.erfinv(2 * p - 1);
  }

  /**
     * Calculates the probability of loss in 12 months for the portfolio
     * Returns the prbability of any loss 
     * @param {*} standard_deviation The standard deviation of the portfolio
     * @param {*} rate_of_return The rate of return of the portfolio
     */
    calculate_probability_loss_in_12_months(standard_deviation, rate_of_return){
      return this.cdf(0, rate_of_return, standard_deviation);
  }

  /**
     * Calculates the amount of money at risk in 12 months for the portfolio (Value at Risk)
     * Returns the amount of money at risk
     * @param {*} standard_deviation The standard deviation of the portfolio
     * @param {*} rate_of_return The rate of return of the portfolio
     * @param {*} starting_value The initial value of the portfolio
     */
    calculate_amount_money_risk_in_12_months(standard_deviation, rate_of_return, starting_value){
      let inverse_normal = this.inv_cdf(.99, 0.0, 1.0);
      
      let amount_money_risk = (((inverse_normal * standard_deviation) - rate_of_return) * starting_value/100);
      if(amount_money_risk < 0.0){
          amount_money_risk = 0.0;
      }
      return amount_money_risk;
  }

  constructor(public currencyPipe: CurrencyPipe, public percentPipe: PercentPipe, public decimalPipe: DecimalPipe,
    private formBuilder: FormBuilder, private router: Router, private cd: ChangeDetectorRef, private dialog: MatDialog, public calculationService: CalculationService) {
    this.chartOptions = {
      series: [
        {
          name: "Small Cap Growth",
          data: this.generateData(8, {
            min: 0,
            max: 100
          })
        },
        {
          name: "Mid Cap Growth",
          data: this.generateData(8, {
            min: 0,
            max: 100
          })
        },
        {
          name: "Large Cap Growth",
          data: this.generateData(8, {
            min: 0,
            max: 100
          })
        },
        {
          name: "US Treasury (1-3 Years)",
          data: this.generateData(8, {
            min: 0,
            max: 100
          })
        },
        {
          name: "High Yield Bonds",
          data: this.generateData(8, {
            min: 0,
            max: 100
          })
        },
        {
          name: "Coroporate Bonds",
          data: this.generateData(8, {
            min: 0,
            max: 100
          })
        },
        {
          name: "Taxable Cash",
          data: this.generateData(8, {
            min: 0,
            max: 100
          })
        },
        {
          name: "Tax-Free Cash",
          data: this.generateData(8, {
            min: 0,
            max: 100
          })
        }
      ],
      chart: {
        height: 600,
        width: 600,
        type: 'heatmap',
        fontFamily: '"Open Sans Regular", sans-serif'
      },
      dataLabels: {
        enabled: true,
        dropShadow: {
          enabled: true,
          left: 0.5,
          top: 0.5,
          opacity: 0.5
        },
      },
      plotOptions: {
        heatmap: {
          colorScale: {
            inverse: true
          }
        }
      },
      colors: [
        // '#388e3c', // Mat Green 700
        // '#d32f2f', // Mat Red 700
        // '#fecd5c', // Chapwood Yellow
        '#244768', // Chapwood Blue Primary 
      ],
      title: {
        text: 'Correlation Matrix',
        align: 'left',
        style: {
          fontSize: '24px',
          fontFamily: '"Open Sans Regular", sans-serif',
          fontWeight: 600
        },
      },
      // colors: [
      //   "#F3B415",
      //   "#F27036",
      //   "#663F59",
      //   "#6A6E94",
      //   "#4E88B4",
      //   "#00A7C6",
      //   "#18D8D8",
      //   "#A9D794",
      //   "#46AF78",
      //   "#A93F55",
      //   "#8C5E58",
      //   "#2176FF",
      //   "#33A1FD",
      //   "#7A918D",
      //   "#BAFF29"
      // ],
      xaxis: {
        labels: {
          style: {
            fontSize: '14px',
          },
          trim: false,
        },
        type: "category",
        categories: [
          "Tax-Free Cash",
          "Taxable Cash",
          "Corporate Bonds",
          "High Yield Bonds",
          "US Treasury (1-3 Years)",
          "Large Cap Growth",
          "Mid Cap Growth",
          "Small Cap Growth",
        ],
      },
      yaxis: {
        labels: {
          style: {
            fontSize: '14px',
          },
        },
      },
    };
  }

  ngOnInit() {
    this.portfolioForm = new FormGroup({
      'allocationTable': new FormGroup({}),
    });
    this.initializeDataSource();
  }

  initializeDataSource() {
    // var assetAllocations = this.portfolioForm.get('currentAssetAllocation').get('assetAllocations') as FormArray;
    // var portfolioValue = this.portfolioForm.get('currentAssetAllocation').get('portfolioValue') as FormControl;
    var portfolioValue = 10000;
    // this.portfolioForm.get('currentAssetAllocation').get('portfolioValue').setValue(this.portfolioForm.get('wegnerAnalysis').get('earnedIncome').get('portfolioValue').value);
    // this.portfolioForm.get('wegnerAnalysis').get('earnedIncome').get('portfolioValue').valueChanges.subscribe(value => {
    //   this.portfolioForm.get('currentAssetAllocation').get('portfolioValue').patchValue(value);
    // })
    var allocationTable = this.portfolioForm.get('allocationTable') as FormGroup;
    ALLOCATION.categories.forEach(category => {
      var categoryForm = new FormGroup({});
      var categoryPercentage = 0;
      var categoryValue = 0;
      (category.assets as Array<Asset>).forEach(asset => {
        // TO-DO: Add asset valueto categoryForm
        var assetForm = new FormGroup({});
        var assetFormPercentage = new FormControl(asset.asset_percentage, [Validators.min(0), Validators.max(100), Validators.pattern(/^-?(0|[1-9]\d*)?$/)]);
        var assetFormValue = new FormControl(asset.asset_value);
        assetFormPercentage.valueChanges.subscribe(percentage => {
          assetFormValue.patchValue(percentage * 0.01 * portfolioValue);
        })
        // var assetControl = new FormControl(asset.asset_percentage);

        // assetControl.valueChanges.subscribe(percentage => {
        //   categoryPercentage += Number(percentage);
        // })
        // categoryForm.addControl(asset.asset_name, assetControl);
        categoryForm.addControl(asset.asset_name +'-percentage', assetFormPercentage);
        categoryForm.addControl(asset.asset_name + '-value', assetFormValue);
        // categoryForm.addControl(asset.asset_name + '-value', new FormControl(asset.asset_percentage));
      })
      var categoryFormPercentage = new FormControl(categoryPercentage);
      var categoryFormValue = new FormControl(categoryFormValue);
      allocationTable.addControl(category.category_name + '-percentage', categoryFormPercentage);
      allocationTable.addControl(category.category_name + '-value', categoryFormValue);
      // allocationTable.addControl(category.category_name + '-percentage', new FormControl(categoryPercentage));
      allocationTable.addControl(category.category_name, categoryForm);
      categoryForm.valueChanges.subscribe((object) => {
        console.log(object);
        categoryPercentage = 0;
        categoryValue = 0;
        Object.keys(object).map(key => {
          if (key.includes('-percentage')){
            categoryPercentage += Number(object[key]);
          }
          else {
            categoryValue += Number(object[key]);
          }
        });
        categoryFormPercentage.patchValue(categoryPercentage);
        categoryFormPercentage.updateValueAndValidity();
        categoryFormValue.patchValue(categoryValue);
        categoryFormValue.updateValueAndValidity();
        // const values = (<any>Object).values(object);
      })
      
      categoryForm.setParent(this.portfolioForm.get('allocationTable') as FormGroup);
      if (category.assets && Array.isArray(category.assets) && category.assets.length) {
        this.categoriesData = [...this.categoriesData, { ...category, assets: new MatTableDataSource(category.assets) }];
      } else {
        this.categoriesData = [...this.categoriesData, category];
      }
    })
    this.categoriesDataSource = new MatTableDataSource(this.categoriesData);
    this.categoriesDataSource.sort = this.sort;
  }

  public generateData(count, yrange) {
    var i = 0;
    var series = [];
    while (i < count) {
      var y =
        Math.floor(Math.random() * (yrange.max - yrange.min + 1)) + yrange.min;

      series.push(y);
      i++;
    }
    return series;
  }


  toggleRow(category: Category) {
    // this.setAssetAllocations((category.assets as MatTableDataSource<Asset>).data.length);
    category.assets && (category.assets as MatTableDataSource<Asset>).data.length ? (this.expandedCategory = this.expandedCategory === category ? null : category) : null;
    this.cd.detectChanges();
    this.innerTables.forEach((table, index) => (table.dataSource as MatTableDataSource<Asset>).sort = this.innerSort.toArray()[index]);
  }
  saveAllocations(){
    // let dialogRef: MatDialogRef<ProgressSpinnerDialogComponent> = this.dialog.open(ProgressSpinnerDialogComponent, {
    //   panelClass: 'transparent',
    //   disableClose: true
    // });
    // setTimeout(()=> {
    //   dialogRef.close();
    // }, 2000)
    // console.log(this.portfolioForm.get('currentAssetAllocation').get('allocationTable'));
  }

  toggleBuilder(){
    if (this.calculationService.page != 'analysis'){
      this.calculationService.page = 'analysis';
    }
    else {
      this.calculationService.page = 'builder';
    }
  }
}
